export const RE_DIRECT_DASHBOARD = () => {
  window.location.href = "/dashboard";
};
export const RE_DIRECT_TO = (route) => {
  window.location.href = String(route);
};
